import { Outlet, createFileRoute } from "@tanstack/react-router";
import { PalletLangProvider } from "@bfc-software/pallet";
import { logger } from "@bfc-software/app-toolbox";
import {
  useTranslation,
  TRANSLATION_NAMESPACE,
} from "@bfc-software/bfc-web-ui/i18n";

export const Route = createFileRoute("/$lang/_layout")({
  component: AppLayout,
});

function AppLayout() {
  const { lang } = Route.useParams();

  // Provide `@bfc-software/pallet` with the ability to use our i18n definitions; These are all managed
  // in the `pallet.json` file here.
  const { t } = useTranslation({
    lang,
    namespace: TRANSLATION_NAMESPACE.pallet,
  });

  logger.info(`Initializing localization context w/ '${lang}'`);

  return (
    <PalletLangProvider simpleTranslate={t}>
      <Outlet />
    </PalletLangProvider>
  );
}

export default AppLayout;
